// Confidence score indicator - 45 lines ✅
import { Badge } from '@/components/ui/badge'
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import { CONFIDENCE_THRESHOLDS } from '@/lib/constants'

interface ConfidenceScoreProps {
  score: number
  showIcon?: boolean
  showLabel?: boolean
  className?: string
}

export function ConfidenceScore({
  score,
  showIcon = true,
  showLabel = true,
  className,
}: ConfidenceScoreProps): JSX.Element {
  const confidence =
    score >= CONFIDENCE_THRESHOLDS.HIGH
      ? 'high'
      : score >= CONFIDENCE_THRESHOLDS.MEDIUM
      ? 'medium'
      : 'low'

  const config = {
    high: { color: 'text-kaycoo-teal-dark', icon: CheckCircle2, label: 'High' },
    medium: { color: 'text-kaycoo-blue-dark', icon: AlertTriangle, label: 'Medium' },
    low: { color: 'text-kaycoo-burgundy-dark', icon: XCircle, label: 'Low' },
  }[confidence]

  const Icon = config.icon

  return (
    <Badge variant="outline" className={cn('gap-1', className)}>
      {showIcon && <Icon className={cn('h-3 w-3', config.color)} />}
      {showLabel && <span>{config.label}</span>}
      <span className="font-mono">{Math.round(score * 100)}%</span>
    </Badge>
  )
}
